import { FrontPage } from "../front/frontPage";
import { FrontPageCalendarTask } from "../front/frontPageCalendarTask";
import { FrontPageDocument } from "../front/frontPageDocument";
import { FrontPageEvent } from "../front/frontPageEvent";
import { FrontPageInstantMessage } from "../front/frontPageInstantMessage";
import { FrontPageMessage } from "../front/frontPageMessage";
import { FrontPageTask } from "../front/frontPageTask";
import { getApiCall } from "./tokenService";

export const getFrontPage = (): Promise<FrontPage> => {
    return getApiCall("api/front", FrontPage);
};

export const getFrontPageMessage = (): Promise<FrontPageMessage> => {
    return getApiCall("api/front/message", FrontPageMessage);
};

export const getFrontPageEvent = (): Promise<FrontPageEvent> => {
    return getApiCall("api/front/event", FrontPageEvent);
};

export const getFrontPageTask = (): Promise<FrontPageTask> => {
    return getApiCall("api/front/task", FrontPageTask);
};

export const getFrontPageDocument = (): Promise<FrontPageDocument> => {
    return getApiCall("api/front/document", FrontPageDocument);
};

export const getFrontPageInstantMessage = (): Promise<FrontPageInstantMessage> => {
    return getApiCall("api/front/instantmessage", FrontPageInstantMessage);
};

export const getFrontPageCalendarTask = (): Promise<FrontPageCalendarTask> => {
    return getApiCall("api/front/calendartask", FrontPageCalendarTask);
};
